<script setup>
import { ref, watch } from 'vue';
import RichTextEditor from 'dashboard/routes/dashboard/settings/components/RichTextEditor.vue';
import NextButton from 'dashboard/components-next/button/Button.vue';

const props = defineProps({
  messageSignature: {
    type: String,
    default: '',
  },
});

const emit = defineEmits(['updateSignature']);
const signature = ref(props.messageSignature);
watch(
  () => props.messageSignature ?? '',
  newValue => {
    signature.value = newValue;
  }
);

const updateSignature = () => {
  emit('updateSignature', signature.value);
};
</script>

<template>
  <form class="flex flex-col gap-6" @submit.prevent="updateSignature()">
    <RichTextEditor
      :model-value="signature"
      show-toolbar
      :show-color-picker="false"
      output-format="markdown"
      min-height="8rem"
      max-height="16rem"
      @update:model-value="signature = $event"
    />
    <div>
      <NextButton
        type="submit"
        :label="$t('PROFILE_SETTINGS.FORM.MESSAGE_SIGNATURE_SECTION.BTN_TEXT')"
      />
    </div>
  </form>
</template>
